import { render, staticRenderFns } from "./ProductionSummary.vue?vue&type=template&id=5db1d16b&scoped=true"
import script from "./ProductionSummary.vue?vue&type=script&lang=js"
export * from "./ProductionSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db1d16b",
  null
  
)

export default component.exports